var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['order-pick-type', `order-pick-type-${_vm.item.id}`]},[_vm._v(_vm._s(_vm.item.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }